import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PdfViewerService {
  public url: string;

  constructor(private router: Router) {}

  public preview(url: string, newTab?: boolean) {
    this.url = url;
    if (newTab) {
      const urlTree = this.router.createUrlTree(['/pdf-viewer'], {
        queryParams: { url },
      });
      const newTabUrl = this.router.serializeUrl(urlTree);
      window.open(newTabUrl, '_blank');
      return;
    }
    this.router.navigate(['/pdf-viewer'], { queryParams: { url } });
  }
}
